import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ParticipantesService } from "../services/participantes.service";

@Injectable({
  providedIn: 'root'
})
export class ParticipantesResolver implements Resolve<boolean> {

  constructor(private service: ParticipantesService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ParticipantesCombosResolver{

  constructor(private service: ParticipantesService) { }

  resolve(id:number = null): Observable<any> {
    return this.service.getListCombos();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ParticipantesResolverId {

  constructor(private service: ParticipantesService) { }

  getById(id:number): Observable<any> {
    return this.service.getById(id);
  }
}